import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  useMediaQuery,
} from "@mui/material";
import ClientReportView from "./ClientReport";
import CandidateReportView from "./CandidateReport";
import StaffReportView from "./StaffReport";
import JobReportView from "./JobReport";
import SystemReportView from "./SystemReport";

const tabLabels = [
  "Clients",
  "Candidates",
  // "Staffs",
  "Jobs",
  "System",
];

const Reports = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  const isMobile = useMediaQuery("(max-width: 1220px)");

  const renderReportContent = () => {
    switch (selectedTab) {
      case 0:
        return <ClientReportView />;
      case 1:
        return <CandidateReportView />;
      case 2:
        return <JobReportView />;
      case 3:
        return <SystemReportView />;

      default:
        return null;
    }
  };

  return (
    <Box>
      <Paper
        sx={{ p: 2, maxWidth: isMobile ? "100vw" : `calc(100vw - 280px)` }}
      >
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          indicatorColor="error"
          textColor="error"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabLabels.map((label, index) => (
            <Tab
              sx={{
                fontFamily: "Geist, sans-serif",
                background: "#f4f4f5",
                border: "2px solid #f4f4f5",
                color: selectedTab !== index ? "black" : "white",
                background: selectedTab !== index ? "#EBF2FF" : "#2C5F8E",
                fontWeight: selectedTab === index ? "600" : "500", // Apply bold if selected
                fontSize: selectedTab === index ? "14px" : "12px",
                letterSpacing: "1px",
                borderRadius: "10px 10px 0px 0px",
                margin: "0px 2px",
                // "&:hover": {
                //   fontWeight: "bold",
                //   textDecoration: "none",
                // },
              }}
              key={index}
              label={label}
            />
          ))}
        </Tabs>
        <Box sx={{ mt: 2 }}>{renderReportContent()}</Box>
      </Paper>
    </Box>
  );
};

export default Reports;
